export class Data<T> {
    public data:T;
}
